<template>
    <div class="intro_container">
        <header-nav></header-nav>
        <banner-component :banner-data="articleListNav"></banner-component>
        <div class="content">
            <!--左-->
            <article-side-bar :article-list-nav="articleListNav"></article-side-bar>
            <!--右-->
            <div class="content_right">
                <div class="content_header">
                    <span class="title">{{curName}}</span>
                    <span class="card">{{articleListNav.menuName}} > {{curName}}</span>
                </div>
                <img class="head_img" :src="colleges.img2" alt="">
                <h1 class="school_name">{{colleges.collegesName}}</h1>
                <p class="intro">
                  <div class="intro_content" v-html="colleges.intro"></div>
                </p>
                <h1 class="school_name">专利情况</h1>
                <ul class="article_box">
                    <li class="article_list" v-for="item in articleList" :key="item.id">
                    <router-link :to="{path:'/patentSearch/patentDetail',query:{menuId:$route.query.menuId,plateId:$route.query.plateId,id:item.id}}">
                    <span class="article_title">
                        <img src="../../assets/images/article/articleRight.png" alt="">{{item.name}}</span>
                        <span class="date">{{item.publishTime}}</span>
                    </router-link>
                    </li>
                </ul>
                <div class="data_null" v-if="articleList==''">
                    暂无数据
                </div>
                <div class="page" v-else >
                    <vue-pagination
                        :current-page="currentPage"
                        :total="totalPage"
                        :page-size="pageSize"
                        @current-change="handleChangeCurrent">
                    </vue-pagination>
                </div>
            </div>
        </div>
        <partner-list></partner-list>
        <common-footer></common-footer>
    </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import ArticleSideBar from '@/components/ArticleSideBar.vue'
  import { queryPatent } from '@/api/Patent.js'
  import colleges from './colleges'
  export default {
    components:{ArticleSideBar, HeaderNav, CommonFooter, PartnerList, BannerComponent},
    data() {
      return {
        search:'',
        articleList: [],
        plateName:'',
        articleId:'',
        //分页参数
        pageSize: 10,
        currentPage: 1,
        totalPage: 100,
      }
    },
    computed: {
      articleListNav: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      },
      curName(){
        let plate = this.articleListNav.children.find((item)=>{
          return item.id == this.$route.query.plateId
        })
        this.handleNav()
        return plate.plateName
      },
      colleges(){
        return colleges.find((item)=>{
          return item.collegesCode == this.$route.query.colleges_code
        })
      }
    },
    created() {
      //this.handleNav()
    },
    methods: {
      handleNav() {
        queryPatent(
          {
            collegesCode: this.$route.query.colleges_code, 
            pageIndex: this.currentPage - 1,
            pageSize: this.pageSize
          } 
        ).then((res) => {
          this.articleList = res.list
          this.pageSize = res.pageParam.pageSize
          this.totalPage = res.pageParam.totalCount
        })
      },
      handleChangeCurrent(val) {
        this.currentPage = val
        this.handleNav()
      },

    }
  }
</script>
<style lang="scss">
  .vue-pagination li a, .vue-pagination li button, .vue-pagination .vue-pagination-skip button, .vue-pagination .vue-pagination-skip input {
    font-size: 16px;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.intro_container{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
}
  //$themeColor: #3e76fc;
  .content {
    width: 1200px;
    display: flex;
    .content_right {
      width: 1112px;
      padding-left: 34px;
      /*position: absolute;*/
      .head_img{
          width: auto;
          max-width: 100%;
          height: auto;
          display: block;
          margin: 30px auto;
      }
      .intro{
          margin-bottom: 30px;
          font-size: 16px;
          line-height: 1.4;
      }
      .intro_content{
        margin-bottom: 30px;
      }
      .school_name{
          font-size: 26px;
          margin-bottom: 20px;
      }
      .content_header {
        width: 100%;
        height: 86px;
        border-bottom: 1px solid $themeColor;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 28px;
          color: $themeColor;
        }
        .card {
          font-size: 14px;
          color: #333;
        }
      }
      .article_box {
        width: 100%;
        min-height: 400px;
        .article_list a{
          height: 54px;
          border-bottom: 1px solid #e1e1e1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .article_title {
            max-width: 860px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            font-size: 16px;
            color: #333;
           padding-right: 20px;
            img {
              width: 10px;
              height: 12px;
              margin-right: 10px;
            }
          }
          .date {
            font-size: 16px;
            color: #666;
          }
        }
        .article_list:hover {
          .article_title, .date {
            color: $themeColor;
          }
        }
      }
      .data_null{
        position: relative;
        top: -300px;
        left: 0;
        text-align: center;
      }
      .page {
        margin: 70px 0 145px 0;
        display: flex;
        justify-content: center;
        .vue-pagination {
          font-size: 16px;
          color: #999;
          .vue-pagination li a {
            font-size: 16px !important;
          }
        }
      }
    }
  }
</style>
